<div class="header main-app">
    <div class="avatar">
        <core-avatar-img [user]="user" [size]="40"> </core-avatar-img>
    </div>
    <div class="info">
        <p>
            <span class="user-name">{{user.name}}</span>
            <span class="user-email"> {{user.email}}</span>
        </p>
    </div>
</div>
